import { useMutation } from '@tanstack/react-query';
import apiClient from '@/lib/api/apiClient';
import { ResetPasswordResetBody, SignUpRequestBody } from '@inversor-hub/types';

export function useSignUp() {
  return useMutation({
    mutationFn: async (userData: SignUpRequestBody) => {
      if (userData.role !== 'psi' && userData.role !== 'investor') {
        throw new Error('Rol no válido. Debe ser "psi" o "inversor"');
      }
      const { data } = await apiClient.post('/auth/signup', userData);
      return data;
    },
  });
}

interface LoginResponse {
  id: string;
  email: string;
  emailValidated: boolean;
  active: boolean;
  token: string;
}

interface LoginCredentials {
  email: string;
  password: string;
}

export const useLogin = () => {
  return useMutation<LoginResponse, Error, LoginCredentials>({
    mutationFn: async (credentials) => {
      const { data } = await apiClient.post<LoginResponse>('/auth/login', credentials);
      return data;
    },
  });
};

interface ConfirmEmailRequest {
  token: string;
}

export const useConfirmEmail = () => {
  return useMutation({
    mutationFn: async (token: string) => {
      await apiClient.post<unknown, ConfirmEmailRequest>('/auth/confirm-email', { token });
    },
  });
};

export const useRequestPasswordReset = () => {
  return useMutation({
    mutationFn: async (email: string) => {
      await apiClient.post('/auth/request-password-reset', { email });
    },
  });
};

export const useResetPassword = () => {
  return useMutation({
    mutationFn: async (body: ResetPasswordResetBody) => {
      await apiClient.post('/auth/reset-password', body);
    },
  });
};
